export enum ROLES {
  ADMINISTRATOR = 'administrator',
  MANAGER = 'manager',
  TEACHER = 'teacher',
  STUDENT = 'student',
  AUTHENTICATED = 'authenticated', //đăng nhập là có quyền
  PERMISSION = 'permission', // checkroute cho 5 tài khoản học sinh demo
  TESTBANK = 'testbank', // nhập liệu test Bank
}
